<h3>Textverarbeitung</h3>


<form class="form-vertical" id="textdocform" name="textdocform">
  <!-- Überweisung für: -->
  <div class="form-group">
    <!-- Patientensuche -->
    <label for="reffor">Patient</label>
    <div class="form-group  col-xs-12" ng-hide="vm.textdoc.patientid">
      <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>
    </div>
    <div class="form-group col-xs-12" ng-show="vm.textdoc.patientid">
      <div class="input-group">
        <input type="text" class="form-control"
               id="patientname"
               tabindex="0"
               readonly
               ng-model="vm.textdoc.patient.fname">
        <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>
                    </button>
                </span>
      </div>
    </div>
  </div>

  <!-- Empfänger Doctor: -->
  <div class="form-group">
    <label for="refto">Empfänger
      (Arzt) <i class="fa fa-info-circle text-primary" uib-tooltip="Wird kein Arzt als Empfänger ausgewählt, wird der Brief an den Patienten adressiert"></i>
    </label>

    <div class=" row">
      <!-- Arztsuche - -->
      <div class="form-group  col-xs-12" ng-hide="vm.textdoc.doctor._id">
        <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>
      </div>
      <div class="form-group col-xs-12" ng-show="vm.textdoc.doctor._id">
        <div class="input-group">
          <input type="text" class="form-control"
                 id="pdoctorname"
                 tabindex="0"
                 readonly
                 ng-model="vm.textdoc.doctor.fname">
          <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>
                    </button>
                </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Betreff -->
  <div class="form-group">
    <label for="subject">Betreff</label>
    <input type="text" class="form-control" id="subject" tabindex="5"
           required placeholder="Betreff" ng-model="vm.textdoc.subject">
  </div>


  <div class="form-group">
    <div><label>Inkludieren</label></div>
    <div class="checkbox">
      <label>
        <input type="checkbox" ng-model="vm.textdoc.getdiagnoses" ng-true-value="true" ng-false-value="false">
        Diagnosen
      </label>
      <label>
        <input type="checkbox" ng-model="vm.textdoc.getdrugs" ng-true-value="true" ng-false-value="false"> Medikamente
      </label>
      <label>
        <input type="checkbox" ng-model="vm.textdoc.getrisks" ng-true-value="true" ng-false-value="false">
        Risikofaktoren
      </label>
      <label>
        <input type="checkbox" ng-model="vm.textdoc.getnotes" ng-true-value="true" ng-false-value="false"> Notizen
      </label>

      <!--      <label>
              <input type="checkbox" ng-model="vm.textdoc.gettodos" ng-true-value="true" ng-false-value="false"> Patienten-Todos
            </label>-->
    </div>
    <div class="checkbox">
      <label>
        <input type="checkbox" ng-model="vm.textdoc.greetings" ng-true-value="true" ng-false-value="false">
        Schlußformel (Mit freundlichen Grüßen ...)
      </label>
    </div>
  </div>


  <!-- WYSIWYG tinymce editor -->
  <textarea ui-tinymce="vm.tinymceOptions" ng-model="vm.xhtml"></textarea>
  <!--<textarea ui-tinymce ng-model="vm.textdoc.text"></textarea>-->


  <!-- Buttons -->
  <div class="spacer-top spacer-bottom">
    <button class="btn btn-success" ng-click="vm.print()"><i class="fa fa-print"></i> Drucken</button>
    <button class="btn btn-info" ng-click="vm.preview()"><i class="fa fa-file-pdf-o"></i> Vorschau</button>
    <button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-remove"></i> Abbrechen</button>
  </div>
</form>


<div class="alert alert-success spacer-top" ng-show="vm.printed === true"><i class="fa fa-check-circle-o fa-2x"></i>&nbsp;Erfolgreich
  gedruckt
</div>
<div class="alert alert-danger spacer-top" ng-show="vm.printed === false"><i class="fa fa-warning fa-2x"></i>&nbsp;Druck
  fehlgeschlagen
</div>